/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthd
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthd {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthd
     */
    payMthdDiv?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthdFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthd {
    return JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthdFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthdFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthd {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payMthdDiv': !exists(json, 'payMthdDiv') ? undefined : json['payMthdDiv'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthdToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePayMthdInfoPayMthd | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payMthdDiv': value.payMthdDiv,
    };
}

